import { render, staticRenderFns } from "./ConfirmContactCustomer.vue?vue&type=template&id=396e3ede&scoped=true&"
import script from "./ConfirmContactCustomer.vue?vue&type=script&lang=js&"
export * from "./ConfirmContactCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmContactCustomer.vue?vue&type=style&index=0&id=396e3ede&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396e3ede",
  null
  
)

export default component.exports